import React, { useRef } from 'react';
import { InputText } from 'primereact/inputtext';

export default (props) => {
  const inputRef = useRef();

  const positionCursor = () => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.selectionStart = inputRef.current.value.length;
      }, 0);
    }
  };

  const formatValue = (floatValue = 0) => {
    if(!floatValue) return '';
    return parseFloat(floatValue).toLocaleString('pt-br', {
      currency: 'BRL',
      style: props.mode || 'decimal',
      minimumFractionDigits: props.maxFractionDigits || 2
    });
  }

  const handleChange = (e) => {
    let value = (e.target.value || '').replace(/\D/g, '').padStart(3, '0');
    let floatValue = 0;
    if (value !== '000') {
      if (value.length > 16) value = value.substring(0, 16);
      const regex = new RegExp(`(\\d*)(\\d{${props.maxFractionDigits || 2}})`, `g`);
      value = value.replace(regex, '$1.$2');
      floatValue = parseFloat(value);
    } 

    if (typeof props.onChange === 'function')
      props.onChange({
        target: {
          value: floatValue
        }
      });
  };

  return (
    <>
      <InputText
        {...props}
        value={formatValue(props.value || 0)}
        inputMode={'numeric'}
        ref={inputRef}
        onChange={handleChange}
        onClick={positionCursor}
      />
    </>
  );
};
